export default __webpack_public_path__ + "static/media/lectureNotesIcon.41752d3c.svg";